export class IGetUserLdap{
    id?: number = 0;
    documentId: number = 0;
    username: string = "";
    email: string = "";
    sn: string = "";
    cn: string = "";
    fullname?: string = "";
}